<template>
  <div class="vue-order-line" :class="{'open' : open}">
    <div class="row head-row px-3 d-none d-lg-flex" @click="open = !open">
      <div class="col-lg-3">
        {{ order.id }}
      </div>
      <div class="col-lg-3">
        {{ formattedDate }}
      </div>
      <div class="col-lg-3">
        {{ Object.keys(order.lines).length ?? 0 }} {{ computedProductText }}
      </div>
      <div class="col-lg-3">
        {{ order.total / 100 | currencyFormatter }}
      </div>
      <div class="col-12 divider-col" v-show-slide="open">
        <div class="divider"></div>
      </div>
    </div>

    <div class="row head-row px-3 d-lg-none" @click="open = !open">
      <div class="col-12">
        <div class="row">
          <div class="col">{{ orderNumberText }}</div>
          <div class="col">{{ order.id }}</div>
        </div>
        <div class="row">
          <div class="col">{{ orderDateText }}</div>
          <div class="col">{{ formattedDate }}</div>
        </div>
        <div class="row">
          <div class="col">{{ amountText }}</div>
          <div class="col">{{ Object.keys(order.lines).length ?? 0 }} {{ computedProductText }}</div>
        </div>
        <div class="row">
          <div class="col">{{ totalTaxText }}</div>
          <div class="col">{{ order.total / 100 | currencyFormatter }}</div>
        </div>
        <div class="row">
          <div class="col-12 divider-col" v-show-slide="open">
            <div class="divider mt-3"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-show-slide="open">

      <div class="col-12 px-5 mt-2">
        <span>{{ shippingCostText }}: {{ order.shipping_costs / 100 | currencyFormatter }}</span>
      </div>

      <div class="col-12 mt-2 mt-lg-4 px-5 text-align-right">
        <button @click="handleClickFavorite" class="btn-ghost" v-html="addToListText"></button>
        <button @click="handleClickToCart" class="btn-primary">{{ addToCartText }}</button>
      </div>

      <dentaid-order-line-item
        v-for="(item, index) in productLines"
        :key="index"
        :item="item"
      ></dentaid-order-line-item>

      <template v-if="giftLine">
        <h4 class="col-12 px-5 pt-6" v-html="yourFreeGift"></h4>
        <dentaid-order-gift-item
          :key="order.id"
          :item="giftLine.model"
        ></dentaid-order-gift-item>
      </template>
    </div>
  </div>
</template>

<script>
import CurrencyFormatter from "../mixins/currency-formatter";
import OrderLineItem from "./OrderLineItem";
import OrderGiftItem from "./OrderGiftItem";
import moment from "moment";
import {usePiniaStore} from "../store/pinia_store";

export default {
  name: "OrderLine",

  mixins: [CurrencyFormatter],

  components: {
    'dentaid-order-line-item': OrderLineItem,
    'dentaid-order-gift-item': OrderGiftItem
  },

  props: {
    order: {
      type: Object
    },
    langCode: {},
    jwtToken: {},
    dentaidApiInstance: {},
    cartEventBus: {},
  },

  data() {
    return {
      open: false,
      productText: window.Drupal.t('products'),
      addToListText: window.Drupal.t('Add to <strong>my list</strong>'),
      addToCartText: window.Drupal.t('Add to my cart'),
      addToCartMessage: window.Drupal.t('Product(s) succesfully added to cart!'),
      addToCartMessageError: window.Drupal.t('Something went wrong when adding products to the cart.'),
      addToFavoritesMessage: window.Drupal.t('Product(s) succesfully added to favorites!'),
      addToFavoriteErrorText: window.Drupal.t('Something went wrong when adding products to favorites list'),
      orderNumberText: window.Drupal.t('Order number'),
      orderDateText: window.Drupal.t('Order date'),
      amountText: window.Drupal.t('Amount'),
      totalTaxText: window.Drupal.t('Total (excl. VAT.)'),
      yourFreeGift: window.Drupal.t('Your free gift'),
      shippingCostText: window.Drupal.t('Shipping cost'),
      piniaStore: usePiniaStore(),
    }
  },

  computed: {
    formattedDate() {
      moment.locale(this.langCode);
      return moment(this.order.created_at).format('D MMMM');
    },

    itemsForCart() {
      return Object.values(this.order.lines).filter(product => product.type === 'Product').map((item) => {
        return {
          sku: item.model.sku,
          quantity: item.quantity,
        }
      });
    },

    itemsForFavorites() {
      return Object.values(this.order.lines).filter(product => product.type === 'Product').map((item) => {
        return {
          sku: item.model.sku,
        }
      });
    },

    giftLine() {
      return Object.values(this.order.lines).find(product => product.type === 'Gift');
    },

    productLines() {
      return Object.values(this.order.lines).filter(product => product.type === 'Product');
    },

    computedProductText() {
      if (this.order.lines.length > 1) {
        return window.Drupal.t('products');
      }

      return window.Drupal.t('product');
    }
  },

  methods: {
    handleClickFavorite() {
      this.dentaidApiInstance.post(`/favorites?token=${this.jwtToken}`, {
        items: this.itemsForFavorites
      })
        .then(response => {
          Vue.$toast.success(this.addToFavoritesMessage);
        })
        .catch(error => {
          Vue.$toast.error(this.addToFavoriteErrorText);
        });
    },

    handleClickToCart() {
      this.dentaidApiInstance.post(`/cart?token=${this.piniaStore.parsedToken}`, {
        items: this.itemsForCart,
      })
        .then(response => {
          Vue.$toast.success(this.addToCartMessage);
          this.piniaStore.updateUserData(response.data.data);
        })
        .catch(error => {
          Vue.$toast.error(this.addToCartMessageError);
        });

    }
  }
}
</script>

<style scoped>

</style>
